module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_7-3544badd939b97cd8ef8e5b5645cc213.jpg";